/* @flow */
import * as React from 'react';
import Icon from 'components/Icon.jsx';
import TooltipTrigger from 'components/TooltipTrigger.jsx';
import type { ColumnHeader } from './ComposableTable.jsx';

type Props = {
  columnHeader: ColumnHeader,
};

export default function ComposableTableHeaderInfoIcon(props: Props) {
  const { columnHeader } = props;
  const { icon } = columnHeader;

  if (icon) {
    return (
      <TooltipTrigger tooltip={icon.tooltip} placement="top">
        <span>
          <Icon name={icon.iconName} size="inherit" />
        </span>
      </TooltipTrigger>
    );
  }

  return null;
}
